<!--
This file is part of the project: "Digiziege"
An app for animal-welfare-oriented goat husbandry and contactless weight estimation.
GitLab: https://gitlab.rlp.net/proj-wise2526-digiziege/digiziege

Copyright (c) 2026 Digiziege Team TH-Bingen

Description:
Companion app for welfare-oriented goat husbandry featuring contactless weight estimation via camera,
master data management and health tracking.
Built as a PWA with a local-first approach to ensure data privacy.

LICENSE INFORMATION:
This program is free software: you can redistribute it and/or modify it under the terms of the
GNU Affero General Public License as published by the Free Software Foundation,
either version 3 of the License, or (at your option) any later version.

This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
See the GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License along with this program.
If not, see <https://www.gnu.org/licenses/>.
-->

<template>
  <div class="min-h-screen bg-[var(--color-bg)] text-[var(--color-text)] p-4 pb-24 flex flex-col gap-6">
    <!-- Grid Layout -->
      <WelcomeModule v-if="showWelcome" @close="handleCloseWelcome" />
      <QuickActionsModule/>
      <RecentActivitiesModule/>
  </div>
</template>

<script>
// State kept outside the component instance to persist across navigation
// but reset on page reload or app restart
let isWelcomeDismissed = false
</script>

<script setup>
  import { useI18n } from 'vue-i18n'
  import { useUiStore } from '@/stores/ui.store.js' 
  import { onMounted, ref } from 'vue'
  import WelcomeModule from '@/components/home/WelcomeTextModule.vue'
  import QuickActionsModule from '@/components/home/QuickActionsModule.vue'
  import RecentActivitiesModule from '@/components/home/RecentActivitiesModule.vue' 

  const { t } = useI18n()
  const uiStore = useUiStore()

  const showWelcome = ref(!isWelcomeDismissed)

  function handleCloseWelcome() {
    showWelcome.value = false
    isWelcomeDismissed = true
  }

  onMounted(() => {
    uiStore.setHeader({
      title: t('views.home.title'),
      showBack: false, 
      showAdd: false   
    })
  })

</script>
